(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden-bd");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden-bd");
    });

    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden-bd");
    });
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    
    // product-img full-view & magnific popup
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });

    // newsletter
    $('label.box-area').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.agree').removeClass('disabled');
      }
      else {
        $('.agree').addClass('disabled');
      }
    });

  });
})(jQuery);

/* ---------------------------------------------------------------
   Defensive accessibility/SEO patch for 3rd-party popup widgets
   (e.g. 1ClickPopup spin-to-win). This only ever ADDS missing
   attributes on elements that already exist on the page; it never
   removes, replaces, or alters any existing behavior, click
   handler, or styling. Safe no-op if those elements are absent.
----------------------------------------------------------------- */
(function () {
  function patchWithin(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;

    // 1) Popup logo image missing alt text
    var logoImgs = root.querySelectorAll('div.logo > img:not([alt]), div.logo > img[alt=""]');
    logoImgs.forEach && logoImgs.forEach(function (img) {
      if (img.closest('[id*="modal-spin-to-win"], [class*="modal-spin-to-win"]')) {
        img.setAttribute('alt', 'Eraya Sparkle');
      }
    });

    // 2) div with aria-label but no role (prohibited ARIA attribute)
    var dismissals = root.querySelectorAll('div.dismissal[aria-label]');
    dismissals.forEach && dismissals.forEach(function (el) {
      if (!el.hasAttribute('role')) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
      }
    });

    // 3) Uncrawlable javascript:void(0) link inside the popup modal
    var dismissLinks = root.querySelectorAll('a.ocp__modal__link[href="javascript:void(0)"]');
    dismissLinks.forEach && dismissLinks.forEach(function (a) {
      a.setAttribute('href', '#page-top');
      // Safety net only: guarantees no accidental page jump even if
      // this runs before the app's own click handler attaches.
      // The app's own dismiss behavior is completely untouched.
      a.addEventListener('click', function (e) { e.preventDefault(); }, true);
    });
  }

  patchWithin(document);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            patchWithin(node);
            if (node.parentNode) patchWithin(node.parentNode);
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // The popup always appears within a few seconds of load; stop
    // observing after 20s so this adds zero ongoing overhead.
    setTimeout(function () { observer.disconnect(); }, 20000);
  }
})();
